import Component from '../Component';
import classList from '../utils/classList';
/**
 * The `FieldSet` component defines a collection of fields, displayed in a list
 * underneath a title.
 *
 * The children should be an array of items to show in the fieldset.
 */
export default class FieldSet extends Component {
  view(vnode) {
    return m("div", {
      className: classList('FieldSet', this.attrs.className),
      role: "group",
      "aria-label": this.attrs.label,
      "aria-disabled": false
    }, m("label", {
      className: "FieldSet-label",
      "aria-hidden": "true"
    }, this.attrs.label), this.attrs.description ? m("div", {
      className: "FieldSet-description helpText"
    }, this.attrs.description) : null, m("div", {
      className: "FieldSet-items"
    }, vnode.children));
  }
}
flarum.reg.add('core', 'common/components/FieldSet', FieldSet);